import { Money } from "@redotech/money";
import classNames from "classnames";
import { memo } from "react";
import { Flex } from "./flex";
import { MoneyText } from "./fx/money-text";
import * as styles from "./product-list-row.module.css";
import { Text } from "./text";

export const ProductListItemQuantity = memo(function ProductListItemQuantity({
  emphasizeQuantity,
  quantity,
  price,
  priceMoney,
}: {
  emphasizeQuantity: boolean;
  quantity: number;
  price: string;
  priceMoney?: Money | null;
}) {
  return (
    <>
      {emphasizeQuantity ? (
        <Flex
          align="center"
          className={classNames(
            styles.quantityContainer,
            quantity > 1 && styles.emphasizeQuantity,
          )}
          justify="center"
        >
          <Text
            fontSize="md"
            fontWeight={quantity > 1 ? "bold" : "regular"}
            textColor={quantity > 1 ? "white" : "secondary"}
          >
            {quantity}
          </Text>
        </Flex>
      ) : (
        <Flex
          flexDirection="column"
          gap="xs"
          justify="center"
          pr="xl"
          textAlign="right"
        >
          <Text fontSize="xs" fontWeight="medium">
            {priceMoney !== undefined ? (
              <MoneyText value={priceMoney} />
            ) : (
              price
            )}
          </Text>
          <Text fontSize="xxs" textColor="secondary">
            Quantity: {quantity}
          </Text>
        </Flex>
      )}
    </>
  );
});
